exports = module.exports = require("../../node_modules/.0.26.4@css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".group[data-v-807bfef8],.url[data-v-807bfef8]{width:300px}.list[data-v-807bfef8]{margin-top:50px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/.0.26.4@css-loader?minimize!./~/.10.3.0@vue-loader/lib/style-rewriter.js?id=data-v-807bfef8&scoped=true!./~/.2.2.3@less-loader!./~/.10.3.0@vue-loader/lib/selector.js?type=styles&index=0!./src/components/list.vue
// module id = 47
// module chunks = 1